module.exports = __webpack_public_path__ + "static/media/HSP40_heatmap.45fcddea.png";